export enum ProjectState {
  up = 'up',
  down = 'down',
  stable = 'stable',
}
